import React from 'react';
import useStyles from 'isomorphic-style-loader/useStyles';
import PropTypes from 'prop-types';

// app: services
import assets from 'services/assets';

// app: constants
import { BREAKPOINTS } from 'constants/index';

import CssHouseAd from './HouseAd.scss';

function HouseAd(props) {
  const { href, mobileImageSrc, imageSrc, format, mobileFormat } = props;

  useStyles(CssHouseAd);

  const sizes = [];
  if (format === 'expanded') {
    sizes.push({ w: 728, h: 270, resize: 'fit-in' });
    sizes.push({ w: 728 * 2, h: 270 * 2, resize: 'fit-in' });
  } else {
    // leaderboard
    sizes.push({ w: 728, h: 90, resize: 'fit-in' });
    sizes.push({ w: 728 * 2, h: 90 * 2, resize: 'fit-in' });
  }

  const mobileSizes = [];
  if (mobileFormat === 'expanded') {
    mobileSizes.push({ w: 320, h: 50, resize: 'fit-in' });
    mobileSizes.push({ w: 320 * 2, h: 50 * 2, resize: 'fit-in' });
  } else {
    // leaderboard
    mobileSizes.push({ w: 320, h: 50, resize: 'fit-in' });
    mobileSizes.push({ w: 320 * 2, h: 50 * 2, resize: 'fit-in' });
  }

  return (
    <div className={`house-ad house-ad--${format} house-ad--mobile-${mobileFormat}`}>
      <a href={href} rel="noopener noreferrer" target="_blank">
        <picture>
          {mobileImageSrc ? (
            <source
              media={`(max-width: ${BREAKPOINTS.PHONE_VERTICAL}px)`}
              srcSet={assets.srcSet(mobileImageSrc, mobileSizes, assets.adUrl)}
            />
          ) : null}
          <source
            media={`(min-width: ${BREAKPOINTS.PHONE_VERTICAL + 1}px)`}
            srcSet={assets.srcSet(imageSrc, sizes, assets.adUrl)}
          />
          <img
            src={assets.adUrl(imageSrc, {
              resize: 'fit-in',
              width: sizes[0].w,
              height: sizes[0].h,
            })}
            alt="Advertisement"
            loading="lazy"
          />
        </picture>
      </a>
    </div>
  );
}

HouseAd.propTypes = {
  format: PropTypes.oneOf(['leaderboard', 'expanded']),
  href: PropTypes.string.isRequired,
  imageSrc: PropTypes.string.isRequired,
  mobileFormat: PropTypes.oneOf(['leaderboard', 'expanded']),
  mobileImageSrc: PropTypes.string,
};

HouseAd.defaultProps = {
  format: 'leaderboard',
  mobileFormat: 'leaderboard',
  mobileImageSrc: null,
};

export default HouseAd;
